import { useEffect } from 'react';

const upsertMeta = (selector, create) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
};

const setNamedMeta = (name, content) => {
  if (content == null) return;
  const el = upsertMeta(`meta[name="${name}"]`, () => {
    const m = document.createElement('meta');
    m.setAttribute('name', name);
    return m;
  });
  el.setAttribute('content', content);
};

const setPropMeta = (prop, content) => {
  if (content == null) return;
  const el = upsertMeta(`meta[property="${prop}"]`, () => {
    const m = document.createElement('meta');
    m.setAttribute('property', prop);
    return m;
  });
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  if (!href) return;
  const el = upsertMeta('link[rel="canonical"]', () => {
    const l = document.createElement('link');
    l.setAttribute('rel', 'canonical');
    return l;
  });
  el.setAttribute('href', href);
};

const setRobots = (content) => {
  const el = upsertMeta('meta[name="robots"]', () => {
    const m = document.createElement('meta');
    m.setAttribute('name', 'robots');
    return m;
  });
  el.setAttribute('content', content);
};

const removeRobots = () => {
  const el = document.head.querySelector('meta[name="robots"]');
  if (el) el.remove();
};

export function useSeo({ title, description, canonical, noindex }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      setNamedMeta('description', description);
      setPropMeta('og:description', description);
      setNamedMeta('twitter:description', description);
    }
    if (title) {
      setPropMeta('og:title', title);
      setNamedMeta('twitter:title', title);
    }
    if (canonical) {
      setCanonical(canonical);
      setPropMeta('og:url', canonical);
    }
    if (noindex) setRobots('noindex, follow');
    else removeRobots();
  }, [title, description, canonical, noindex]);
}
